var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("emd-modal", {
    attrs: { "has-header": "", open: _vm.modalState },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.tfaIsEnabled
              ? _c(
                  "form",
                  {
                    staticClass: "el-chunk eu-no-pb",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.deleteTfa.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "emd-text _color_subtle eu-mt_4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("description")) + " "),
                      _c("span", { staticClass: "emd-text _type_bold" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedUser.first_name) +
                            " " +
                            _vm._s(_vm.selectedUser.last_name) +
                            " " +
                            _vm._s("(" + _vm.selectedUser.id + ")") +
                            "? "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "eu-flex eu-justify_space-arround eu-width_100 eu-no-margin eu-pt_5",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "emd-btn _color_success _type_outline _block_mobile eu-basis_5 eu-basis_12_mobile eu-order_2_mobile eu-mt_3_mobile",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.closeModal.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("cancel-button"))),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "emd-btn _color_success _block_mobile eu-grow_1 eu-ml_1_sm eu-order_1_mobile",
                            attrs: { disabled: _vm.isLoading, type: "submit" },
                          },
                          [
                            _vm.isLoading
                              ? _c("emd-loader", { attrs: { type: "_subtle" } })
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.$t("success-button"))),
                                ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _c("div", { staticClass: "el-chunk eu-no-pb" }, [
                  _c("p", { staticClass: "emd-text _color_subtle eu-mt_4" }, [
                    _vm._v(" " + _vm._s(_vm.$t("success-title")) + " "),
                    _vm.selectedUser
                      ? _c("span", { staticClass: "emd-text _type_bold" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedUser.first_name) +
                              " " +
                              _vm._s(_vm.selectedUser.last_name) +
                              " " +
                              _vm._s("(" + _vm.selectedUser.id + ")") +
                              ". "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "eu-flex eu-justify_space-arround eu-width_100 eu-no-margin eu-pt_5",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "emd-btn _color_success _block_mobile eu-grow_1 eu-ml_1_sm eu-order_1_mobile",
                          attrs: { disabled: _vm.isLoading },
                          on: { click: _vm.closeModal },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("success-confirm-button"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }